import { Download, ScanLine, QrCode } from "lucide-react";
import Reveal from "@/components/ui/reveal";

const STEPS = [
    {
        icon: Download,
        title: "Załóż konto w kilka minut",
        desc: "Pobierz aplikację, skonfiguruj profil JDG i połącz swoje dane. Bez papierologii i skomplikowanego onboardingu.",
    },
    {
        icon: ScanLine,
        title: "Rób zdjęcia i wystawiaj faktury",
        desc: "Faktury KSeF FA-2 wystawisz jednym tapnięciem, a paragony i koszty wpadają do księgowości automatycznie dzięki OCR i AI.",
    },
    {
        icon: QrCode,
        title: "Płać podatki i śpij spokojnie",
        desc: "Gotowe kody QR do ZUS i US, KPiR na autopilocie oraz przypomnienia o terminach — wszystko pilnuje aplikacja.",
    },
];

export default function HowItWorks() {
    return (
        <section id="jak-to-dziala" className="py-20 lg:py-28">
            <div className="container-gr">
                <div className="max-w-2xl">
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">Jak to działa</p>
                    <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">Księgowość w trzech krokach</h2>
                    <p className="mt-4 text-lg text-muted-foreground">Od instalacji do spokojnej głowy — bez arkuszy i bez stresu.</p>
                </div>

                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.title} delay={i * 0.08} className="relative">
                            <div data-testid={`how-step-${i}`} className="h-full rounded-2xl border border-border bg-card p-7">
                                <div className="flex items-center justify-between">
                                    <div className="grid h-12 w-12 place-items-center rounded-xl bg-gr-secondary text-gr-primary dark:bg-gr-dsecondary dark:text-gr-dprimary">
                                        <s.icon className="h-6 w-6" />
                                    </div>
                                    <span className="font-mono text-4xl font-extrabold text-gr-line dark:text-gr-dline">0{i + 1}</span>
                                </div>
                                <h3 className="mt-6 text-xl tracking-tight text-foreground">{s.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
